<template>
	<div>
        <SubNav v-bind:active="1"></SubNav>
		<div class="profile-img">
			<img v-bind:src="imgUrl" alt="">
		</div>
		<div class="profile-content">
            <Row :gutter="0" justify="center">
                <Col span="12">
                    <img src="../../../public/img/bg_03.jpg">
                </Col>
                <Col span="12">
                    <Form ref="solutionForm" :model="solutionForm" :label-width="80" :rules="ruleSolution">
                        <FormItem label="产品" prop="product">
                            <Input v-model="solutionForm.product" placeholder="请输入产品名"/>
                        </FormItem>
                        <FormItem label="姓名" prop="name">
                            <Input v-model="solutionForm.name" placeholder="请输入姓名"/>
                        </FormItem>
                        <FormItem label="手机" prop="mobile">
                            <Input v-model="solutionForm.mobile" placeholder="请输入手机"/>
                        </FormItem>
                        <FormItem label="用途" prop="use">
                            <Input v-model="solutionForm.use" placeholder="请输入用途"/>
                        </FormItem>
                        <FormItem label="地区" prop="area">
                            <Cascader :data="areaData" v-model="solutionForm.area"></Cascader>
                        </FormItem>
                        <FormItem style="margin-bottom: 0">
                            <Checkbox v-model="solutionForm.check"> 我同意收到来自东风随州专用汽车有限公司的推广信息</Checkbox>
                        </FormItem>
                        <FormItem style="text-align: justify">
                            <div style="line-height: 20px">为了能够更好的为您推荐车型及提供相关服务，请您如实填写以上内容。对于您所提供的个人信息我们将尊重您的隐私并严格保密。</div>
                        </FormItem>
                        <FormItem>
                            <Button type="error" @click="toSubmit('solutionForm')">提交</Button>
                        </FormItem>
                    </Form>
                </Col>
            </Row>
		</div>
	</div>
</template>

<script>
    import SubNav from './SubNav.vue'
	import VDistpicker from 'v-distpicker'
	import * as product from '@/controller/product'
	import area from '@/config/area'

	export default {
		name: "solution",
		components: {
			VDistpicker, SubNav
		},
		data() {
			return {
				imgUrl: '',
				solutionForm: {
					product: '',
					name: '',
					mobile:'',
					use: '',
					check: true,
					area: []
				},
				ruleSolution: {
					product: [
						{ required: true, message: '输入不能为空', trigger: 'blur' }
					],
					name: [
						{ required: true, message: '输入不能为空', trigger: 'blur' }
					],
					mobile: [
						{ required: true, message: '输入不能为空', trigger: 'blur' },
						{ required: true, pattern:/^[1][3,4,5,6,7,8][0-9]{9}$/, message:'请输入正确的手机号格式', trigger:'blur' }
					],
					use: [
						{ required: true, message: '输入不能为空', trigger: 'blur' }
					],
					area: [
						{ required: true, type: 'array', min: 1, message: '请选择地区', trigger: 'change' }
					]
				},

				areaData: area.data
			}
		},
		mounted() {
			this.showBanner()
		},
		methods: {
			//显示banner图
			showBanner() {
				product.fetchBanner()
					.then(result => {
						this.imgUrl = result.imgUrl.solution
					})
			},
			toSubmit(name) {

				this.$refs[name].validate((valid) => {
					if (valid) {

						const obj = new Object()
						obj.product = this.solutionForm.product
						obj.name = this.solutionForm.name
						obj.mobile = this.solutionForm.mobile
						obj.purpose = this.solutionForm.use
						obj.province = this.solutionForm.area[0]
						obj.city = this.solutionForm.area[1]

						product.submitSolution(obj)
							.then(result => {
								this.$Message.success(`${result.solution.message}`)

								if(result.solution.status == 0) {
									this.solutionForm.product = ''
									this.solutionForm.name = ''
									this.solutionForm.mobile = ''
									this.solutionForm.use = ''
									this.solutionForm.area = []
								}
							})

					}
				})
			}
		}
	}
</script>

<style scoped lang="stylus">
    .profile-img
        background-color white
        overflow hidden
        img
            width 100%
    .profile-content
        width 1000px
        margin 0 auto
        padding 60px 10px
        img
            width 380px
            height 350px
</style>